import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { Heading, H2, Reviews } from '../../components';

import css from './ListingPage.module.css';

const SectionReviews = props => {
  const { reviews, fetchReviewsError } = props;
  const reviewsCount = reviews?.length || 0;

  return (
    <section className={css.sectionReviews}>
      <Heading as="h2" rootClassName={css.sectionHeadingWithExtraMargin}>
        <FormattedMessage id="ListingPage.reviewsTitle" values={{ count: reviewsCount }} />
      </Heading>
      {fetchReviewsError ? (
        <H2 className={css.errorText}>
          <FormattedMessage id="ListingPage.reviewsError" />
        </H2>
      ) : null}
      {!fetchReviewsError && reviewsCount === 0 ? (
        <p className={css.reviewsEmpty}>
          <FormattedMessage id="ListingPage.reviewsEmpty" />
        </p>
      ) : (
        <Reviews reviews={reviews} />
      )}
    </section>
  );
};

export default SectionReviews;
